import React, { Component } from "react";

import { Metric } from "components/Utils/Utils.js";
import Heading from "components/Elements/Heading";

class LeeSubscribersSummary extends Component {
  render() {
    const { data } = this.props;

    return (
      <div className="row">
        <div className="col-12 col-md-9">
          <div className="row">
            {data.new_subscriptions_yesterday && (
              <div className="mb-3 col-6 col-md-3 ">
                <Heading size={6} className={"mb-1"}>
                  New Subscriptions Yesterday
                </Heading>
                <Metric {...data.new_subscriptions_yesterday} size={"lg"} />
              </div>
            )}

            {data.digital_subscriptions_yesterday && (
              <div className="mb-3 col-6 col-md-3 ">
                <Heading size={6} className={"mb-1"}>
                  Digital Subscriptions Yesterday
                </Heading>
                <Metric {...data.digital_subscriptions_yesterday} size={"lg"} />
              </div>
            )}

            {data.full_access_subscriptions_yesterday && (
              <div className="mb-3 col-6 col-md-3 ">
                <Heading size={6} className={"mb-1"}>
                  Full Access Subscriptions Yesterday
                </Heading>
                <Metric
                  {...data.full_access_subscriptions_yesterday}
                  size={"lg"}
                />
              </div>
            )}

            {data.pct_audience_as_digital && (
              <div className="mb-3 col-6 col-md-3 ">
                <Heading size={6} className={"mb-1"}>
                  % of Audience as Digital
                </Heading>
                <Metric
                  {...data.pct_audience_as_digital}
                  size={"lg"}
                  format={"%"}
                />
              </div>
            )}

            {data.pct_audience_as_digital && (
              <div className="mb-3 col-6 col-md-3 ">
                <Heading size={6} className={"mb-1"}>
                  % of App Subscriptions
                </Heading>
                <Metric
                  {...data.app_subscriptions_pct}
                  size={"lg"}
                  format={"%"}
                />
              </div>
            )}

            {data.new_subscriptions_last_week && (
              <div className="mb-3 col-6 col-md-3 ">
                <Heading size={6} className={"mb-1"}>
                  New Subscriptions Last Week
                </Heading>
                <Metric {...data.new_subscriptions_last_week} size={"lg"} />
              </div>
            )}
            {data.total_active_subscriptions && (
              <div className="col-6 col-md-3">
                <Heading size={6} className={"mb-1"}>
                  Total Active Subscriptions Last Week
                </Heading>
                <Metric {...data.total_active_subscriptions} size={"lg"} />
              </div>
            )}
          </div>
          {data.current_period_digital_goal && data.var_to_goal && (
            <div className="row">
              <div className="mb-3 col-3">
                <Heading size={6} className={"mb-1"}>
                  Current Period Digital Goal
                </Heading>
                <Metric {...data.current_period_digital_goal} size={"lg"} />
              </div>

              <div className="mb-3 col-3">
                <Heading size={6} className={"mb-1"}>
                  Var to Goal
                </Heading>
                <Metric {...data.var_to_goal} size={"lg"} />
              </div>
            </div>
          )}
        </div>

        <div className="col-12 col-md-3">
          <div className="row">
            <div className="col-12 align-items-center">
              <div className="mb-1 d-flex justify-content-left align-items-center">
                <h6 className="mb-0 mr-2">Breakout Subscriptions By System</h6>
              </div>
              <div className="d-flex justify-content-left align-items-center">
                <h6 className="mb-0 mr-2">Falcon Digital Only</h6>
                <Metric {...data.falcon_digital} size={"xs"} />
              </div>
              <div className="d-flex justify-content-left align-items-center">
                <h6 className="mb-0 mr-2">Falcon Full Access</h6>
                <Metric {...data.falcon_full} size={"xs"} />
              </div>
              <div className="d-flex justify-content-left align-items-center">
                <h6 className="mb-0 mr-2">DSI Digital Only</h6>
                <Metric {...data.dsi_digital} size={"xs"} />
              </div>
              <div className="d-flex justify-content-left align-items-center">
                <h6 className="mb-0 mr-2">DSI Full Access</h6>
                <Metric {...data.dsi_full} size={"xs"} />
              </div>
              <div className="d-flex justify-content-left align-items-center">
                <h6 className="mb-0 mr-2">DTI Digital Only</h6>
                <Metric {...data.dti_digital} size={"xs"} />
              </div>
              <div className="d-flex justify-content-left align-items-center">
                <h6 className="mb-0 mr-2">DTI Full Access</h6>
                <Metric {...data.dti_full} size={"xs"} />
              </div>
              <div className="d-flex justify-content-left align-items-center">
                <h6 className="mb-0 mr-2">STL Digital Only</h6>
                <Metric {...data.stl_digital} size={"xs"} />
              </div>
              <div className="d-flex justify-content-left align-items-center">
                <h6 className="mb-0 mr-2">STL Full Access</h6>
                <Metric {...data.stl_full} size={"xs"} />
              </div>
              <div className="d-flex justify-content-left align-items-center">
                <h6 className="mb-0 mr-2">Apps</h6>
                <Metric {...data.app_subscriptions} size={"xs"} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default LeeSubscribersSummary;
